<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-five">
<h1>Chapter Five</h1>
<p>Nervously, she twiddled her thumbs, her face pale and taut, and her body rigid as she sat stiffly on the hard, high-backed chair. Why had she been summoned? She didn’t have the slightest clue. Still, she rummaged her head for possible reasons; all proved nil and void. Her eyes, when not on the closed door, surveyed her fellow pupils sauntering by; some she knew well, and others were mere acquaintances; most she didn’t know at all. More than one cast a cursory glance her way, making her feel a touch more conspicuous than she cared to feel. She dropped her eyes to the tiled floor, unwilling to engage in any form of eye contact; wishing the bell would ring and disperse them all. The tightly knotted coil in her clenched stomach tightened further. Her eyes lifted to the door and dropped once more.</p>
<p>The door opened.</p>
<p>“Abigail.”</p>
<p>Thousands of erratic butterflies crashed and burned in her knotted gut. She took a deep breath.</p>
<p>The middle-aged woman extended the door wider, and Abigail walked through. Her young eyes settled firmly on the back of a framed photograph sitting on a neat desk, her mind wondering what the image depicted: a husband, a daughter, a son’s graduation, a pet dog?</p>
<p>“Abigail.”</p>
<p>Eyes shifted to the head teacher, who was now sitting behind her tidy desk with an open file perched on top. Slowly, Abigail raised her eyes to meet the eyes of authority, the knot in her tight stomach becoming ever tighter and her heart pumping furiously and threatening to jump out of her chest. The smile appearing on Missus Hamilton’s lips allayed the anxiety bubbling within the teenager, but she still wondered what on earth she was doing, sitting in the head teacher’s study.</p>
<p>“Abigail, please don’t be anxious; you have not been called here to be reprimanded in any way.”</p>
<p>The explanation given brought with it more questions than answers.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch009.vue?7c6c5938